<!-- Tag PROD only -->
<!-- Google Tag Manager (noscript) -->
<noscript>
    <iframe src="https://www.googletagmanager.com/ns.html?id=GTM-P6SS96D"
            height="0" width="0" style="display:none;visibility:hidden">
    </iframe>
</noscript>
<!-- End Google Tag Manager (noscript) -->
<div class="container-full-width">
    <div class="page-container">
        <div class="product-sale-container">
            <div class="content" fxLayout="row" fxLayoutAlign="start">
                <div #filter class="filter-wrapper">
                    <app-product-sale-filter>
                    </app-product-sale-filter>
                </div>
                <div class="banner-wrapper">
                    <div *ngFor="let slider of sliders">
                        <app-sale-slider [slider]="slider"></app-sale-slider>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
